import { ComponentRef } from '@angular/core';
import { DataObject } from '@miq/shared-models';
/*
 * L2-R6: moved from `src/app/shared/decorators/member-state.ts` because WizardComponent (also moved
 * here) is its only library-side consumer. 12 host components still use the @StateMember decorator
 * through the re-export shim left at the old path.
 */
export const StateMemberSymbol = Symbol('_stateMembers');
/**
 * Property decorator to build a map of state members in a class
 * @param target
 * @param propertyKey
 */
export function StateMember(target: Object, propertyKey: string) {
  if (!target.hasOwnProperty(StateMemberSymbol)) {
    Object.defineProperty(target, StateMemberSymbol, {
      enumerable: true,
      configurable: true,
      writable: true,
    });
    target[StateMemberSymbol] = {};
  }
  if (!target[StateMemberSymbol][propertyKey]) {
    target[StateMemberSymbol] = { ...target[StateMemberSymbol], [propertyKey]: true };
  }
}
/**
 * Class decorator to define internally a method to retrieve the state of the component
 * based on flagged @StateMember property decorator
 * @param target
 */
export function WithStateMembers(target: any) {
  if (!target.prototype.StateMembers) {
    target.prototype.StateMembers = function () {
      return Object.keys(this[StateMemberSymbol] || {}).reduce(
        (acc, member) => ({ ...acc, [member]: this[member] }),
        {}
      );
    };
  }
}
/**
 * Type with `StateMembers` function
 */
export type WithStateMembersType = DataObject & { StateMembers(): DataObject };
/**
 * If componentRef.instance contains `StateMembers` function return it as WithStateMembersType type
 * else return null
 * @param componentRef
 */
export function asWithStateMemberType(componentRef: ComponentRef<any>) {
  if (isWithStateMemberCompatible(componentRef)) {
    return componentRef.instance as WithStateMembersType;
  }
  return null;
}
/**
 * Checks if passed ComponentRef instance contains `StateMembers` function
 * @param componentRef
 */
function isWithStateMemberCompatible(componentRef: ComponentRef<any>): boolean {
  return (
    componentRef &&
    componentRef.instance &&
    componentRef.instance['StateMembers'] &&
    typeof componentRef.instance['StateMembers'] === 'function'
  );
}
